module.exports = __webpack_public_path__ + "a8a10a3e/img/placeholder.888fcd0b.svg";